import React, { useEffect, useState } from 'react'
import { Box, Button, Checkbox, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material'
import { Item } from '../../../../common/snippets'
import moment from 'moment'
import Datepicker from '../../../../common/datePicker'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { focusElemnt, isEmpty, navigation1, navigation3, removeDuplicatesFromArray } from '../../../../common/helper'
import DropDownOA from '../../../../common/dropDownOA'
import { getColumnDefsTwo, getColumnDefstwoFilter, getColumnDefsTwoV2, getHeaderTblDefs, tab2Data } from './constants'
import { useTranslation } from '../../../../../i18n/I18nProvider'
import TablePaginationCustom from '../../../../common/TablePagination'
import Lineinput from '../../../../common/lineinput'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import EditIcon from '@mui/icons-material/Edit'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { connect } from 'react-redux'
import { GetBankAccountDetailUpdate, GetMOFPaymentUpdate, updateAlertError, updateModal } from '../../../../../store/common/common_action'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import ManageColumns from '../../../../common/ManageColumnsUI'
import { getPartyConfigTableData } from '../../../../../store/generalSetting/GSAction'
import { creditReceiveInsertUpdatePartyVoucher, getPartyVoucherCreditData, updateInsertPartyVoucherDiscount } from '../../../../../store/Acounting/acounting_action'
import SuccessAndErrorModal from '../../../../common/SuccessAndErrorModal'
import LineinputV2 from '../../../../common/lineinputV2'
import { CleanHands } from '@mui/icons-material'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from '../../../../common/font/font/Roboto-bold';
import { callAddFontRobotoMedium } from '../../../../common/font/font/Roboto-Medium-normal';
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth, generateDynamicColumnStyles } from '../../../../common/helper';

const CreditVoucherTab = (props) => {
    const {
        data, updateAlertError, updateModal, getPartyConfigTableData, getPartyVoucherCreditData, updateInsertPartyVoucherDiscount,creditReceiveInsertUpdatePartyVoucher,
        GetMOFPaymentUpdate,GetBankAccountDetailUpdate} = props
    const { translations } = useTranslation()
    const rdcn = translations?.rechargeDebitCreditNote || {}
    const cs = translations?.common || {}
    const columnDefsTwo = getColumnDefsTwo(translations)
    const columnDefstwoFilter = getColumnDefstwoFilter(translations)
    const columnDefsTwoV2 = getColumnDefsTwoV2(translations)
    const headerTblDefs = getHeaderTblDefs(translations)
    const { common, generalSettingReducer } = data
    const { partyConfigTableData } = generalSettingReducer
    const { loginData, showModal, modalType, methodOfPayment, bankAccountDetail } = common
    const [filters, setFilters] = useState({ fromDate: moment(new Date()), toDate: moment(new Date()), transactionType: '', partyCity: '', partyName: '', partyGSTN: '' })
    const [tableData, setTableData] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(50)
    const [page, setPage] = useState(0)
    const [manageColumn, setManageColumn] = useState([])
    const [partyCityList, setPartyCityList] = useState([])
    const [partyNameList, setPartyNameList] = useState([])

    const [partyGSTINList, setPartyGSTINList] = useState([])
    const [reportData, setReportData] = useState([])
    const [isSave, setIsSave] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const [showTable, setShowTable] = useState(false)
    const [selectedValues, setSelectedValues] = useState([])
    const [btmSectData, setBtmSectData] = useState({ GSTAmt:0, NetAmt:0, TotalPaidAmt:0,NetAmtPending:0, Discount: 0,TotalPendingAmount:0, NetAmtToRcv:0,
        paymentMode:'', paymentRefId:'', bankAccNo:'', remarks:''
    })
  const [methodOfPaymentData, setMethodOfPaymentData] = useState([])
  const [bankAccountDetailData, setBankAccountDetailData] = useState([])
  const [resetDD, setResetDD] = useState(false)
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
 
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }
      useEffect(()=>{
        focusElemnt('fromDate')
      },[])
      useEffect(() => {
        if (loginData) {
          GetMOFPaymentUpdate({ intBranchID: loginData?.intBranchID })
          GetBankAccountDetailUpdate({ CompanyID: loginData?.intCompanyID, BranchID: loginData?.intBranchID })
        }
      }, [loginData])
    useEffect(() => {
        const getLocalData = (key) => {
            return new Promise((resolve) => {
                const localData = localStorage.getItem(key)
                resolve(localData ? JSON.parse(localData) : null)
            })
        }

        const updateColumnDetails = async () => {
            try {
                const localColoumnDispatchDetails1 = await getLocalData('columnDefsTwoV2')
                setManageColumn(localColoumnDispatchDetails1 || columnDefsTwoV2)
            } catch (error) {
                // Handle error if necessary
                setManageColumn(columnDefsTwoV2)
                console.error(error)
            }
        }
        updateColumnDetails()
    }, [])
    useEffect(() => {
        if (methodOfPayment?.status === 'Success') {
            let newData = methodOfPayment?.Data?.Table?.filter((val)=>val.ModeID!==2)
          setMethodOfPaymentData(newData)
        } else {
          setMethodOfPaymentData([])
        }
      }, [methodOfPayment])
      useEffect(() => {
        if (bankAccountDetail?.status === 'Success') {
          setBankAccountDetailData(bankAccountDetail?.Data?.Table)
        } else {
          setBankAccountDetailData([])
        }
      }, [bankAccountDetail])
      useEffect(() => {
        if (!isEmpty(loginData)) {
            let object = {
                intPartyID: 0,
                intCompanyID: loginData?.intCompanyID,
                strPartyName: "",
                strContactPerson: "",
                intCityID: 0,
                intIsCreditParty: -1,
                intIsActive: -1,
                intIsDeleted: -1
            }
            getPartyConfigTableData(object)
        }
    }, [loginData])
    useEffect(() => {
        if (partyConfigTableData?.length > 0) {
            const partyCity = partyConfigTableData.flatMap((party) => {
                const cityIds = party.CityID.split("~");
                const cityNames = party.PartyCitiesNames.split("~");
                return cityIds.map((id, index) => ({
                    PartyID: party.PartyID,
                    Party: party.Party,
                    CityID: id,
                    CityName: cityNames[index] || "",
                }));
            });
            const uniqueCity = removeDuplicatesFromArray(partyCity, 'CityID')
            const loginCity = uniqueCity?.filter((val)=>val.CityID==loginData?.intBranchCityID)
            setPartyCityList(uniqueCity)
            // const filteredParty = partyConfigTableData.filter(item => item.CityID.split("~").includes(loginCity?.[0]?.CityID));
            const filteredParty = partyConfigTableData.filter(item => {
                const firstCityID = item.CityID.split("~")[0]; // Get the first substring
                return firstCityID === loginCity?.[0]?.CityID; // Compare it with loginCity's CityID
            });
            setPartyNameList(filteredParty)
            setFilters((prev)=>({...prev,partyCity:loginCity?.[0], partyName:filteredParty?.[0]}))
            // const gstinNumList = partyConfigTableData?.map(record => ({ id: record.GSTN, name: record.GSTN }))
            // const gstinNumListData = removeDuplicatesFromArray(gstinNumList, 'id')
            // setPartyGSTINList(gstinNumListData)
        }
    }, [partyConfigTableData])

   

    useEffect(()=>{
        if(tableData?.length>0){
             let newData = tableData?.filter((item)=>item.isSelected)
             const totalValues = {
                GSTAmt: Math.round(newData.reduce((acc, item) => acc + (parseFloat(item.GSTAmt) || 0), 0)),
                NetAmt: Math.round(newData.reduce((acc, item) => acc + (parseFloat(item.NetAmt) || 0), 0)),
                TotalPaidAmt: Math.round(newData.reduce((acc, item) => acc + (parseFloat(item.TotalPaidAmt) || 0), 0)),
                NetAmtPending: Math.round(newData.reduce((acc, item) => acc + (parseFloat(item.NetAmtPending) || 0), 0)),
                Discount: Math.round(newData.reduce((acc, item) => acc + (parseFloat(item.discuontValue) || 0), 0)),
            };
            // if(totalValues?.NetAmtPending==0){
            //     updateAlertError({ show: true, msg: 'There is no amount pending for the vouchers selected', nextId: '' })
            //     handleGenerate()
            // }else{
                setBtmSectData((prev)=>({
                    ...prev,...totalValues, TotalPendingAmount:totalValues?.NetAmtPending-totalValues?.Discount
                }))
            // }
        }
    },[JSON.stringify(tableData.map(item => item.isSelected))])
    const onSaveColumns = (item) => {
        setManageColumn(item)
        localStorage.setItem('columnDefsTwoV2',JSON.stringify(item))
      }
  const headerBody = [{ fromDate: moment(filters?.fromDate).format('DD-MM-YYYY'), toDate: moment(filters?.toDate).format('DD-MM-YYYY'), partyCity: filters?.partyCity?.CityName, partyName: filters?.partyName?.Party }]
    
      const generatePdf = () => {
        // let pdfDetailedTblBody = getPdfTblData();
        try {
          const widthCell = calculateTotalTableWidth(columnDefs)
    
          jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
          jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
          const doc = new jsPDF({ orientation: columnDefs.length > 13 ? 'l' : 'p', format: columnDefs.length > 13 ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60) : calculateDynamicFormatPortrait((widthCell > 900 ? widthCell : 900) + 60), unit: 'px', compress: true })
    
          var totalPagesExp = doc.internal.getNumberOfPages();
          doc.autoTableSetDefaults({
            headStyles: { fontSize: 16, width: 'auto', halign: 'left', fillColor: '#BFE1FF' },
          })
          const pdfColumnDefs = columnDefs?.filter((item)=>item.dataKey!== 'editDisc')
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
          var pdfFontSize = pageWidth / (pdfColumnDefs.length > 13 ? 1122 : 793);
          doc.setProperties({
            title: `CreditVoucher.pdf`,
            subject: rdcn.creditVoucher || 'Credit Voucher',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Credit Voucher',
            creator: 'MTLPL',
          })
    
          var totalPagesExp = '{total_pages_count_string}'
          const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
    
            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
              str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(pdfFontSize * 14)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 300, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
          }
          autoTable(doc, {
            margin: { left: 30, right: 30, bottom: 5 },
            startY: 190,
            alternateRowStyles: {
              fillColor: [255, 255, 255],
            },
            theme: 'grid',
            columns: headerTblDefs,
            body: headerBody,
            headStyles: {
              fillColor: [191, 225, 255],
              textColor: [0, 0, 0],
              minCellHeight: 36,
              valign: 'middle',
              cellPadding: 12,
              fontSize: pdfFontSize * 14,
              lineWidth: 0.6,
              font: 'Roboto',
              fontStyle: "normal"
            },
            columnStyles: {
              0: { textColor: [0, 0, 0], fontSize: pdfFontSize * 14, cellPadding: 12, minCellHeight: 36, valign: 'middle', minCellWidth: 180, font: 'Roboto', fontStyle: 'normal', halign: 'left' },
              1: { textColor: [0, 0, 0], fontSize: pdfFontSize * 14, cellPadding: 12, minCellHeight: 36, valign: 'middle', minCellWidth: 180, font: 'Roboto', fontStyle: 'normal', halign: 'left' },
              2: { textColor: [0, 0, 0], fontSize: pdfFontSize * 14, cellPadding: 12, minCellHeight: 36, valign: 'middle', minCellWidth: 180, font: 'Roboto', fontStyle: 'normal', halign: 'left' },
              3: { textColor: [0, 0, 0], fontSize: pdfFontSize * 14, cellPadding: 12, minCellHeight: 36, valign: 'middle', minCellWidth: 180, font: 'Roboto', fontStyle: 'normal', halign: 'left' },
            },
            didParseCell: function (data) {
              if (data.row.index === 0) {
                data.cell.styles.textColor = '#000000';
              }
            },
            didDrawPage: function (data) {
              doc.setTextColor(0, 0, 0)
              doc.setFontSize(pdfFontSize * 16)
              doc.setFont("Roboto", 'normal')
              doc.text(`${rdcn.creditVoucher || 'Credit Voucher'} `, 30, 170)
              doc.setFontSize(pdfFontSize * 16)
              doc.setFont("Roboto", 'bold')
              doc.text(`${rdcn.fromVoucherDate || 'From Voucher Date'}: ${moment(filters?.fromDate).format('DD-MMM-YYYY')} ${rdcn.toVoucherDate || 'To Voucher Date'}: ${moment(filters?.toDate).format('DD-MMM-YYYY')}`, doc.internal.pageSize.width - data.settings.margin.left, 170, 'right')
              jsPdfHeaderFooter(data, loginData, totalPagesExp);
            }
          })
    
          autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 60 },
            startY: doc.lastAutoTable.finalY+20,
            alternateRowStyles: {
              fillColor: [255, 255, 255],
            },
            theme: 'grid',
            columns: pdfColumnDefs,
            showHead: 'everyPage',
            body: tableData,
            tableLineWidth: 0.6,
            rowPageBreak: 'avoid',
            styles: {
              lineWidth: [0, 0.6, 0, 0.6]
            },
            columnStyles: generateDynamicColumnStyles(pdfColumnDefs, pdfFontSize * 12),
            headStyles: {
              fillColor: [191, 225, 255],
              textColor: [0, 0, 0],
              fontSize: pdfFontSize * 12,
              minCellHeight: 36,
              cellPadding: 6,
              valign: 'top',
              font: 'Roboto',
              fontStyle: "normal"
            },
    
            didParseCell: function (data) {
              var rows = data.table.body
              if (data.row.section === 'head') {
                if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                  data.cell.styles.halign = "right";
                } else {
                  data.cell.styles.halign = "left";
                }
              }
              rows.map((val) => {
                if (val.raw.isTotalRow) {
                  let prevColSpan = 0;
                  for (let key in val.raw) {
                    if (key == 'srNo') {
                      val.cells[prevColSpan].text = val.raw.srNo.toString();
                      val.cells[prevColSpan].colSpan = Object.keys(matchFields).length;
                      val.cells[prevColSpan].styles.halign = 'right'
                      prevColSpan += Object.keys(matchFields).length;
                    }
                    else {
                      if (key !== 'isTotalRow') {
                        if (selectedFields.hasOwnProperty(key)) {
                          val.cells[prevColSpan].text = val.raw[key].toString();
                          prevColSpan += 1;
                        }
                      }
                    }
                  }
                }
              })
            },
            willDrawCell: (data) => {
              if (data.row.raw.isTotalRow) {
                doc.setFillColor(238, 238, 238);
                doc.setFontSize(pdfFontSize * 12)
                doc.setTextColor(0, 0, 0);
                data.cell.styles.valign = 'middle';
    
              }
            },
            didDrawPage: function (data) {
              doc.setTextColor(pdfFontSize * 40)
              doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
              doc.setFontSize(pdfFontSize * 20).setFont("Roboto", 'bold')
              doc.setTextColor(16, 79, 162)
              doc.text(`${rdcn.cargoSystemPartyVoucher || 'Cargo System | Party Voucher'} | ${rdcn.creditVoucher || 'Credit Voucher'}`, 30 + 60, 80)
              doc.setTextColor(0, 0, 0)
              doc.setFontSize(pdfFontSize * 20).setFont("Roboto", 'normal')
              doc.text(`${cs.companyName || 'Company Name'} :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
              jsPdfHeaderFooter(data, loginData, totalPagesExp);
            }
          })
          doc.setFont('Roboto')
          if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
          }
            doc.save(`${rdcn.creditVoucher || 'Credit Voucher'} ${currentDateTime}.pdf`)
            
        } catch (err) {
          console.log(err)
        }
      }
    const handleRowChkChange = (e, index, row) => {
        let newData = [...tableData]
        newData[index].isSelected = e.target.checked
        setTableData(newData)
    }
   
    const handleHideEditBtn = (index) => {
        let newVal = [...tableData]
        if (index >= 0 && index <= newVal?.length) {
            for (let i = 0; i < newVal?.length; i++) {
                if (i === index) {
                    newVal[i].editBtn = !newVal[i].editBtn
                } else {
                    newVal[i].editBtn = true
                }
            }
            setTableData(newVal)
        }
    }
    const handleCrossBtn = (index) => {
        let newVal = [...tableData]
        if (index >= 0 && index <= newVal?.length) {
            newVal[index].discuontValue = tableData[index].Discount
            newVal[index].editBtn = !newVal[index].editBtn
            setTableData(newVal)
        }
    }
    const handleGenerate = () => {
        if (filters?.partyName === '') {
            updateAlertError({ show: true, msg: rdcn.pleaseSelectPartyName || 'Please Select Party Name', nextId: 'gv-partyName' });
        } else {
            let body = {
                PartyID: filters?.partyName?.PartyID || 0,
                CompanyID: loginData?.intCompanyID,
                FrmDate: moment(filters?.fromDate).format('YYYY-MM-DD'),
                toDate: moment(filters?.toDate).format('YYYY-MM-DD'),
            };
            
            getPartyVoucherCreditData(body).then((res) => {
                if (res.status === 'Success') {
                    let data = res?.Data?.Table?.map((item, i) => ({
                        ...item,
                        srNo: i + 1,
                        isSelected: false,
                        discuontValue: item.Discount,
                        VoucherDate: item.VoucherDate === '' || item.VoucherDate === null || item.VoucherDate === undefined ? '' : moment(item.VoucherDate).format('DD-MMM-YY, hh:mm A'),
                        BookingDate: item.BookingDate === '' || item.BookingDate === null || item.BookingDate === undefined ? '' : moment(item.BookingDate).format('DD-MMM-YY, hh:mm A'),
                        GSTDate: item.GSTDate === '' || item.GSTDate === null || item.GSTDate === undefined ? '' : moment(item.GSTDate).format('DD-MMM-YY, hh:mm A'),
                        editBtn: true
                    }));
    
                    const totalRow = {
                        isTotalRow: true,
                        srNo: cs.total || 'Total',
                        GSTAmt: Math.round(data.reduce((acc, item) => acc + (parseFloat(item.GSTAmt) || 0), 0)),
                        NetAmt: Math.round(data.reduce((acc, item) => acc + (parseFloat(item.NetAmt) || 0), 0)),
                        TotalPaidAmt: Math.round(data.reduce((acc, item) => acc + (parseFloat(item.TotalPaidAmt) || 0), 0)),
                        NetAmtPending: Math.round(data.reduce((acc, item) => acc + (parseFloat(item.NetAmtPending) || 0), 0)),
                        Discount: Math.round(data.reduce((acc, item) => acc + (parseFloat(item.discuontValue) || 0), 0)),
                        NetAmtToRcv: Math.round(data.reduce((acc, item) => acc + (parseFloat(item.NetAmtToRcv) || 0), 0)),
                    };
                    setTableData([...data, totalRow]);
                    setShowTable(true);
                } else {
                    setTableData([]);
                    setShowTable(true);
                    updateAlertError({ show: true, msg: rdcn.noData || 'No Data', nextId: '' });
                }
            }).catch((error) => {
                setTableData([]);
                setShowTable(false);
                updateAlertError({ show: true, msg: error, nextId: '' });
            });
        }
    };
    const handleReceiveBtn = () => {
        if(btmSectData.NetAmtToRcv>btmSectData.TotalPendingAmount){
            updateAlertError({ show: true, msg: rdcn.amountToReceiveCannotBeGreaterThanTotalPending || 'Amount To Receive Cannot Be Greater Than The Total Pending Amount', nextId: '' });
        }else{
        const filteredDataVal = tableData?.filter((item) => item.isSelected);
        let body = {
            CompanyID: 0,
            BookingIDs: '',
            PartyID: filters?.partyName?.PartyID,
            UserID: loginData?.intUserID,
            NetAmts: '',
            TotalPaidAmts: '',
            ReceivedAmts: '',
            VoucherNos: '',
            DiscountAmts: '',
            NetAmtToRcv: '',
            ModeOfPayment: btmSectData?.paymentMode?.ModeID,
            ReferenceID: '',
            AccountNo: '',
            Remarks: btmSectData?.remarks
        };
    
        let netAmtToRcv = parseFloat(btmSectData.NetAmtToRcv) || 0; // Ensure it's a number
        let strVoucherNos = '';
        let strBookingIDs = '';
        let strNetAmts = '';
        let strDiscountAmts = '';
        let strTotalPaidAmts = '';
        let strReceivedAmts = '';
    
        for (const item of filteredDataVal) {
            const netAmtPending = item.NetAmtToRcv || 0; // Ensure it's a number
    
            // Check if the current item's NetAmtPending is greater than NetAmtToRcv
            if (netAmtPending > netAmtToRcv && netAmtToRcv!==0) {
                // If it is, we can't process this item, so we break the loop
                strVoucherNos += strVoucherNos ? `^${item.VoucherNo}` : item.VoucherNo; // Add without ^ if empty
                strBookingIDs += strBookingIDs ? `^${item.Bookingid}` : item.Bookingid; // Add without ^ if empty
                strNetAmts += strNetAmts ? `^${netAmtPending}` : netAmtPending; // Add without ^ if empty
                strDiscountAmts += strDiscountAmts ? `^${item.discuontValue}` : item.discuontValue; // Add without ^ if empty
                strTotalPaidAmts += strTotalPaidAmts ? `^${item.TotalPaidAmt}` : item.TotalPaidAmt; // Add without ^ if empty
                strReceivedAmts += strReceivedAmts ? `^${netAmtToRcv}` : netAmtToRcv;
                netAmtToRcv = 0
                break;
            } else {
                // If it's less than or equal, subtract it from NetAmtToRcv
                netAmtToRcv -= netAmtPending;
    
                // Collect the necessary data
                strVoucherNos += strVoucherNos ? `^${item.VoucherNo}` : item.VoucherNo; // Add without ^ if empty
                strBookingIDs += strBookingIDs ? `^${item.Bookingid}` : item.Bookingid; // Add without ^ if empty
                strNetAmts += strNetAmts ? `^${netAmtPending}` : netAmtPending; // Add without ^ if empty
                strDiscountAmts += strDiscountAmts ? `^${item.discuontValue}` : item.discuontValue; // Add without ^ if empty
                strTotalPaidAmts += strTotalPaidAmts ? `^${item.TotalPaidAmt}` : item.TotalPaidAmt; // Add without ^ if empty
                strReceivedAmts += strReceivedAmts ? `^${netAmtPending}` : netAmtPending; // Add without ^ if empty
            }
    
            // Now handle the case where the amount being paid is less than the amount to be received
            // if (netAmtPending <= netAmtToRcv) {
            //     // If the amount to receive is greater than or equal to the amount pending
            //     // We can pay the full pending amount
            //     strReceivedAmts += strReceivedAmts ? `^${netAmtPending}` : netAmtPending; // Add without ^ if empty
            // } else {
            //     // If the amount to receive is less than the amount pending
            //     // We can only pay the amount we have available
            //     strReceivedAmts += strReceivedAmts ? `^${netAmtToRcv}` : netAmtToRcv; // Add without ^ if empty
            //     // Set the received amount to the amount we can pay
            //     netAmtToRcv = 0; // All amount has been received, so set to 0
            //     break; // Exit the loop since we can't pay any more
            // }
        }
    
        // Update the body object with the collected data
        body.BookingIDs = strBookingIDs;
        body.VoucherNos = strVoucherNos;
        body.NetAmts = strNetAmts;
        body.DiscountAmts = strDiscountAmts;
        body.TotalPaidAmts = strTotalPaidAmts;
        body.ReceivedAmts = strReceivedAmts;
        body.NetAmtToRcv = btmSectData.NetAmtToRcv// Convert back to string if needed
        // Now you can use the body object as needed, e.g., send it in an API request
        creditReceiveInsertUpdatePartyVoucher(body).then((res) => {
            if (res.status === 'Success') {
                setIsSave(true)
            }
        }).catch((error) => {
            updateAlertError({ show: true, msg: error, nextId: '' });
        }) 
    }
    };
  
    const handleInputChange = (e, key, index) => {
        let newData = [...tableData]
        newData[index][key] = e.target.value
        setTableData(newData)
    }
    const handleDiscountSave = (row, index) => {
        if (row?.discuontValue > row?.NetAmtPending) {
            updateAlertError({ show: true, msg: rdcn.discountValueCannotBeMoreThanPendingAmount || 'Discount Value Cannot Be More Than The Pending Amount', nextId: '' });
            handleCrossBtn(index)
        } else {
            let body = {
                CompanyID: loginData?.intCompanyID,
                BookingIDs: row?.Bookingid,
                PartyID: row?.PartyID,
                UserID: loginData?.intUserID,
                DiscountAmts: row?.discuontValue,
                NetAmountToReceive: row?.NetAmtPending - row?.discuontValue,
                VoucherNos: row?.VoucherNo
            }
            updateInsertPartyVoucherDiscount(body).then((res) => {
                if (res.status === 'Success') {
                    setIsSave(true)
                }
            }).catch((error) => {
                updateAlertError({ show: true, msg: error, nextId: '' });
            })
        }

    }
    const handleCloseSuccessModal = () => {
        handleGenerate();
        setIsSave(false);
        setIsSuccess(false)
        setBtmSectData({ GSTAmt:0, NetAmt:0, TotalPaidAmt:0,NetAmtPending:0, Discount: 0,TotalPendingAmount:0, NetAmtToRcv:0,
            paymentMode:'', paymentRefId:'', bankAccNo:'', remarks:''
        })
        setResetDD(true)
        setTimeout(() => {
            setResetDD(false)
        }, 0)
    }
    const columnDefs = manageColumn.filter((obj) => obj.isSelected)
    const mainHeader = ['srNo', 'VoucherNo', 'VoucherDate', 'BookingDate', 'LRNO', 'Party', 'GSTN', 'PaymentType', 'TransactionType', 'GSTInv', 'GSTDate']
    let selectedFields = manageColumn.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.dataKey]: true }), {})
    const matchFields = Object.fromEntries(
        Object.entries(selectedFields).filter(([key]) => mainHeader.includes(key))
    );
    return (
        <>
            <Grid container sx={{ display: 'flex', flexWrap: 'nowrap', gap: '16px', padding: '12px 15px 4px 15px' }}>
                <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
                        <Datepicker
                            label={rdcn.fromVoucherDate || 'From Voucher Date'}
                            id={'fromDate'}
                            value={filters?.fromDate}

                            dateChange={(date) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    fromDate: date
                                }))
                                focusElemnt('toDate')
                                setShowTable(false)
                            }}
                            width="100%"
                        />
                    </Item>
                </Grid>
                <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx }} className="input--container bookingDatePicker">
                        <Datepicker
                            label={rdcn.toVoucherDate || 'To Voucher Date'}
                            id={'toDate'}
                            value={filters?.toDate}

                            dateChange={(date) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    toDate: date
                                }))
                                focusElemnt('gv-partyCity')
                                setShowTable(false)
                            }}
                            width="100%"
                        />
                    </Item>
                </Grid>
                <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx, width:'100%' }} className="input--container">
                        <DropDownOA
                            id={'gv-partyCity'}
                            label={(rdcn.partyCity || 'Party City').replace(/\n/g, ' ')}
                            data={partyCityList || []}
                            defaultvalue={filters?.partyCity?.CityName}
                            value={filters?.partyCity?.CityName}
                            onSelect={(val) => {
                                let filteredParty = []
                                if (partyConfigTableData?.length > 0) {
                                     filteredParty = partyConfigTableData.filter(item => {
                                        const firstCityID = item.CityID.split("~")[0]; // Get the first substring
                                        return firstCityID === val?.CityID; // Compare it with loginCity's CityID
                                    });
                                    // filteredParty = partyConfigTableData.filter(item => item.CityID.split("~").includes(filters?.partyCity?.CityID));
                                    setPartyNameList(filteredParty)
                                }
                                setFilters((prev) => ({
                                    ...prev,
                                    partyCity: val,
                                    partyName: filteredParty?.[0] || ''
                                }))
                                setShowTable(false)
                            }}
                            onReset={() => {

                            }}
                            onSelResetVal={true}
                            idKey={`CityID`}
                            dataKey={`CityName`}
                            nextId={`gv-partyName`}
                            prevId={`toDate`}
                            width={'100%'}
                        />
                    </Item>
                </Grid>
                <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx,  }} className="input--container">
                        <DropDownOA
                            id={'gv-partyName'}
                            label={(rdcn.partyName || 'Party Name').replace(/\n/g, ' ')}
                            data={partyNameList || []}
                            defaultvalue={filters?.partyName?.Party}
                            value={filters?.partyName?.Party}
                            onSelect={(val) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    partyName: val
                                }))
                                setShowTable(false)
                            }}
                            onReset={() => {

                            }}
                            onSelResetVal={true}
                            width={'100%'}
                            idKey={`PartyID`}
                            dataKey={`Party`}
                            nextId={`load_Btn`}
                            prevId={`gv-partyCity`}
                        />
                    </Item>
                </Grid>
                {/* <Grid item md={1.5}>
                    <Item sx={{ ...sx.itemsx }} className="input--container">
                        <DropDownOA
                            id={'gv-partyGSTN'}
                            label={rdcn.partyGstn || 'Party GSTN'}
                            data={partyGSTINList || []}
                            defaultvalue={filters?.partyGSTN?.name}
                            value={filters?.partyGSTN?.name}
                            onSelect={(val) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    partyGSTN: val
                                }))
                                setShowTable(false)
                            }}
                            onReset={() => {

                            }}
                            idKey={`id`}
                            dataKey={`name`}
                            nextId={`'load_Btn'`}
                            prevId={`gv-partyName`}
                        />
                    </Item>
                </Grid> */}
                <Grid item md={1}>
                    <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                        <Button
                            variant="contained"
                            onKeyDown={(e) => navigation3(e, 'printBtn', 'gv-partyName', () => { })}
                            id={'load_Btn'}
                            sx={{ width: '100%', paddingY: '6px !important' }}
                            className="btn btn-primary"
                            onClick={() => { handleGenerate() }}
                        >
                            {cs.generate || 'Generate'}
                        </Button>
                    </Item>
                </Grid>
                <Grid item md={0.8}>
                    <Item sx={{ ...sx.itemsx }} className="">
                        <Button
                            variant="outlined"
                            color="secondary"
                            id={'printBtn'}
                            sx={{ width: '100%' }}
                            className="receiveitembtn"
                            onClick={() => {
                                generatePdf()
                            }}
                            onKeyDown={(e) => navigation3(e, 'exportBtn', 'load_Btn', () => { })}
                        >
                            {rdcn.printUpper || 'PRINT'}
                        </Button>
                    </Item>
                </Grid>
                <Grid item md={0.8}>
                    <Item sx={{ ...sx.itemsx }} className="">
                        <Button
                            variant="outlined"
                            color="secondary"
                            id={'exportBtn'}
                            sx={{ width: '100%' }}
                            className="receiveitembtn"
                            onClick={() => {
                                document.getElementById("test-table-xls-button").click();
                            }}
                            onKeyDown={(e) => navigation3(e, 'filterBtn', 'printBtn', () => { })}

                        >
                            {rdcn.excel || 'EXCEL'}
                        </Button>
                        <ReactHtmlTableToExcel
                            id="test-table-xls-button"
                            className="hidden"
                            table="table-to-xls" // Make sure to set the correct table ID
                            filename={rdcn.creditVoucher || 'Credit Voucher'}
                            sheet="tablexls"
                            buttonText=""
                        />
                    </Item>
                </Grid>
                <Grid item md={1.9}>
                    <Item sx={{ ...sx.itemsx }} className="">
                        <Button
                            variant="outlined"
                            color="secondary"
                            id={'filterBtn'}
                            sx={{ width: '100%' }}
                            className="receiveitembtn"
                            onClick={() => updateModal(true, 'showManageColumn')}
                            onKeyDown={(e) => navigation3(e, 'amtToRecv', 'exportBtn', () => { })}
                        >
                            {rdcn.manageColumn || 'Manage Column'}
                        </Button>
                    </Item>
                </Grid>
            </Grid>
            {showTable ?<Box sx={{ padding: '12px 15px 4px 15px' }}>
                <TableContainer className='scrollBlue' component={Paper} style={{ marginBottom: '5px', maxHeight: '45vh', overflowX: 'auto' }}>
                    <Table
                        stickyHeader
                        size="small"
                        aria-label="a dense table"
                        sx={{
                            '&.MuiTableCell-root': {
                                padding: '6px 8px!important',
                            },
                        }}
                    >
                        <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                            <TableRow>
                                {columnDefs?.map((col, index) => (
                                    <TableCell key={`CityHeader-${index}`} sx={{
                                        ...col.headerSx,
                                        backgroundColor: '#DAEDFE',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#444',
                                        height: '36px',
                                        whiteSpace: 'pre',
                                        padding: '6px'
                                    }}>
                                        {col.headerName}
                                    </TableCell>
                                ))}

                            </TableRow>
                            {/* <TableRow sx={{ '& .MuiTableCell-root': { padding: '6px !important' } }}>
                                {columnDefs.map((col, index) => (
                                    col.showfilter ? (
                                        <TableCell key={`FTH-${index}`}>
                                            <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                                <input
                                                    id={`Contains-${index}`}
                                                    className="field"
                                                    // value={searchData[col.field]}
                                                    name="cancelSearchInput"
                                                    style={{ width: '100%' }}
                                                    placeholder="Contains"
                                                // onChange={(e) => handleSearchData(e, col.field)}
                                                // onKeyDown={(e) => keyboardNavigation(e, index === 1 ? "createBtn" : `Contains-${index - 1}`, index === 11 ? reportData.length > 0 ? `Edit-0` : 'status' : `Contains-${index + 1}`)}
                                                />
                                                <FilterAltIcon sx={{ paddingRight: '0px !important', color: '#aaa !important' }} />
                                            </div>
                                        </TableCell>
                                    ) : <TableCell key={`FTH-${index}`}></TableCell>
                                ))}
                            </TableRow> */}
                        </TableHead>
                        {tableData?.length > 1 ? <TableBody>
                            {(
                                // rowsPerPage > 0
                                //     ? tableData.slice(
                                //         page * rowsPerPage,
                                //         page * rowsPerPage + rowsPerPage
                                //     )
                                //     : 
                                    tableData
                            ).map((val, index) => (
                                val?.isTotalRow ?
                                    <TableRow>
                                        <TableCell colSpan={Object.keys(matchFields).length} sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                            {val?.srNo}
                                        </TableCell>
                                        {selectedFields.hasOwnProperty('GSTAmt') &&
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE',textAlign: 'right' }}>
                                            {val?.GSTAmt}
                                        </TableCell>
                                         } 
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                            {val?.NetAmt}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right'}}>
                                            {val?.TotalPaidAmt}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right'}}>
                                            {val?.NetAmtPending}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right'}}>
                                            {val?.Discount}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right'}}>

                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE',textAlign: 'right' }}>
                                            {val?.NetAmtToRcv}
                                        </TableCell>
                                    </TableRow> :
                                    <TableRow>
                                        <TableCell sx={{ height: '60px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right', minWidth: '50px' }}>
                                            <Checkbox
                                                id={`ma-chkbox-${index}`}
                                                checked={val.isSelected}
                                                sx={{
                                                    height: '20px', // Adjust height as needed
                                                    width: '20px', // Adjust width as needed
                                                    padding: '0px 20px 0px 0px', // Remove padding
                                                    margin: '0', // Remove margin
                                                    verticalAlign: 'middle', // Align vertically
                                                    lineHeight: 'normal' // Adjust line height
                                                }}
                                                onChange={(e) => handleRowChkChange(e, index, val)}
                                            />
                                            {val?.srNo}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.VoucherNo}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.VoucherDate}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.BookingDate}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.LRNO}
                                        </TableCell>
                                        {selectedFields.hasOwnProperty('Party') &&
                                        <TableCell sx={{ height: '40px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.Party}
                                        </TableCell>
                                         }
                                        {selectedFields.hasOwnProperty('GSTN') &&
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.GSTN}
                                        </TableCell>
                                        }
                                        <TableCell sx={{ height: '40px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.PaymentType}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.TransactionType}
                                        </TableCell>
                                        {selectedFields.hasOwnProperty('GSTInv') &&
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.GSTInv}
                                        </TableCell>
                                        } 
                                        {selectedFields.hasOwnProperty('GSTDate') &&
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.GSTDate}
                                        </TableCell>
                                         } 
                                        {selectedFields.hasOwnProperty('GSTAmt') &&
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right'}}>
                                            {val?.GSTAmt}
                                        </TableCell>
                                        }
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px',textAlign: 'right' }}>
                                            {val?.NetAmt}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right'}}>
                                            {val?.TotalPaidAmt}
                                        </TableCell>
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right'}}>
                                            {val?.NetAmtPending}
                                        </TableCell>
                                        {val.editBtn ? <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right'}}>
                                            {val?.discuontValue}
                                        </TableCell> :
                                            <TableCell className="input--wrapper" sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                                <Item sx={{ width: '100%', padding: '0px' }}>
                                                    <input
                                                        id={`focApprAuthName-${index}`}
                                                        name={`focApprAuthName-${index}`}
                                                        className='input--style'
                                                        // autoFocus={manageFocus}
                                                        style={{ fontSize: "12px" }}
                                                        value={val?.discuontValue || 0}
                                                        onChange={(e) => handleInputChange(e, 'discuontValue', index)}
                                                    // onBlur={(e) => { setManageFocus(false) }}
                                                    // onKeyDown={(e) => { navigation3(e, `chkbox-${index}`, `checkMark-${index}`) }}
                                                    />
                                                </Item>
                                            </TableCell>
                                        }
                                        {val.editBtn ? <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', width: '70px' }}>
                                            <span id={`editBtn-${index}`} tabIndex={0} style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold', width: '52px', padding: '2px 4px', marginLeft: '-6px' }}
                                                onClick={() => { handleHideEditBtn(index) }}
                                            // onKeyDown={(e) => navigation3(e, index === filteredData?.length - 1 ? 'mtMonthName' : `editBtn-${index + 1}`, index === 0 ? "monthlyTargetGoBtn" : `editBtn-${index - 1}`, () => { handleHideEditBtn(index); })}
                                            >
                                                <EditIcon sx={{ marginRight: '3px' }} />
                                                {cs.edit || 'Edit'}
                                            </span></TableCell> :
                                            <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', width: '70px', padding: '0px 0px' }}>
                                                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap' }}>
                                                    <span tabIndex={0} key={`checkMark-${index}`} id={`checkMark-${index}`}
                                                        onClick={() => {handleDiscountSave(val, index) }}
                                                        style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px' }}
                                                    // onKeyDown={(e) => navigation3(e, `xMark-${index}`, `chkbox-${index}`, () => { setEditData(val); setShowConfirmation(true) })}
                                                    >
                                                        <CheckCircleOutlinedIcon tabIndex={0} style={{ color: '#4CAF50', marginTop: '1px' }} fontSize='large' />
                                                    </span>
                                                    <span key={`xMark-${index}`} tabIndex={0} id={`xMark-${index}`}
                                                        onClick={() => handleCrossBtn(index)}
                                                        style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px' }}
                                                    // onKeyDown={(e) => navigation3(e, `mtTargetValue-${index}`, `checkMark-${index}`, () => handleCrossBtn(index))}
                                                    >
                                                        <CancelOutlinedIcon tabIndex={0} style={{ color: 'red', marginTop: '1px' }} fontSize="large" />
                                                    </span>
                                                </div>
                                            </TableCell>}
                                        <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right'}}>
                                            {val?.NetAmtToRcv}
                                        </TableCell>
                                    </TableRow>

                            ))}
                        </TableBody> :
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={columnDefs?.length}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginTop: '20px',
                                                marginBottom: '20px',
                                                color: 'red',
                                                fontSize: '14px',
                                            }}
                                        >
                                            <span>{rdcn.noResultsFoundForFilters || 'No Results Found For The Selected Filters.'}</span>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>}
                    </Table>
                    <Table
                        id='table-to-xls'
                        stickyHeader
                        size="small"
                        aria-label="a dense table"
                        sx={{
                            '&.MuiTableCell-root': {
                                padding: '6px 8px!important',
                            },
                            display: 'none'
                        }}
                    >
                        <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                            <TableRow>
                                <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={9}>
                                    <h3 style={{ paddingLeft: '17px' }}>{rdcn.reportCreditVoucher || 'Report: Credit Voucher '}</h3>
                                </TableCell>
                                <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={8}>
                                    <h3 style={{ paddingLeft: '17px' }}>{`${cs.companyName || 'Company Name'} : ${loginData.strCompanyName}`}</h3>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={columnDefsTwo.length - 1}></TableCell>
                            </TableRow>
                            <TableRow >
                                {columnDefstwoFilter
                                    .map((val, index) => (
                                        <TableCell
                                            key={`FTR-${index}`}
                                            style={{
                                                backgroundColor: '#BFE1FF',
                                                fontSize: '18px',
                                                fontWeight: '600',
                                                textAlign: 'left',
                                                color: '#444',
                                            }}
                                            colSpan={val.colSpan}
                                        >
                                            {val.headerName}
                                        </TableCell>
                                    ))
                                }
                            </TableRow>
                            <TableRow >
                                <TableCell key={`FTR-fromDate`} style={{ fontSize: '18px', textAlign: 'left', fontWeight: "500", color: '#444' }} colSpan={4}>{ moment(filters?.fromDate).format('DD-MM-YYYY')}</TableCell>
                                <TableCell key={`FTR-toDate`} style={{ fontSize: '18px', textAlign: 'left', fontWeight: "500", color: '#444' }} colSpan={4}>{ moment(filters?.toDate).format('DD-MM-YYYY')}</TableCell>
                                <TableCell key={`FTR-partyCity`} style={{ fontSize: '18px', textAlign: 'left', fontWeight: "500", color: '#444' }} colSpan={4}>{ filters?.partyCity?.CityName}</TableCell>
                                <TableCell key={`FTR-partyName`} style={{ fontSize: '18px', textAlign: 'left', fontWeight: "500", color: '#444' }} colSpan={5}>{ filters?.partyName?.Party}</TableCell>
                                {/* <TableCell key={`FTR-PartyGST`} style={{ fontSize: '18px', textAlign: 'left', fontWeight: "500", color: '#444' }} colSpan={3}>{ filters?.partyGSTN?.name}</TableCell> */}
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={columnDefsTwo.length - 1}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                            <TableRow>
                                {columnDefsTwo?.map((col, index) => (
                                    col.field !== 'editDisc' ? <TableCell key={`CityHeader-${index}`} style={{
                                        ...col.headerSx,
                                        backgroundColor: '#DAEDFE',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#444',
                                        height: '36px',
                                        whiteSpace: 'pre',
                                        padding: '6px'
                                    }}>
                                        {col.headerName}
                                    </TableCell> : ''
                                ))}

                            </TableRow>
                        </TableHead>

                        {tableData?.length > 1 ? <TableBody>
                            {(
                                // rowsPerPage > 0
                                //     ? tableData.slice(
                                //         page * rowsPerPage,
                                //         page * rowsPerPage + rowsPerPage
                                //     )
                                //     : 
                                    tableData
                            ).map((val, index) => (
                                val?.isTotalRow ?
                                <TableRow>
                                <TableCell colSpan={11} sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                    {val?.srNo}
                                </TableCell>
                                <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', }}>
                                    {val?.GSTAmt}
                                </TableCell>
                                <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right' }}>
                                    {val?.NetAmt}
                                </TableCell>
                                <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right'}}>
                                    {val?.TotalPaidAmt}
                                </TableCell>
                                <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right'}}>
                                    {val?.NetAmtPending}
                                </TableCell>
                                <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right'}}>
                                    {val?.Discount}
                                </TableCell>
                                <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE', textAlign: 'right'}}>

                                </TableCell>
                                <TableCell sx={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', backgroundColor: '#EEEEEE',textAlign: 'right' }}>
                                    {val?.NetAmtToRcv}
                                </TableCell>
                            </TableRow> :
                                    <TableRow>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', textAlign: 'right', minWidth: '50px' }}>
                                            {val?.srNo}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.VoucherNo}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.VoucherDate}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.BookingDate}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.LRNO}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.Party}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.GSTN}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', width: '12%', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.PaymentType}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.TransactionType}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.GSTInv}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.GSTDate}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.GSTAmt}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.NetAmt}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.TotalPaidAmt}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.NetAmtPending}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.discuontValue}
                                        </TableCell>
                                        <TableCell style={{ height: '40px', fontSize: '12px', fontWeight: '500', color: '#444', padding: '6px', }}>
                                            {val?.NetAmtToRcv}
                                        </TableCell>
                                    </TableRow>

                            ))}
                        </TableBody> :
                            <TableBody>
                                <TableRow>
                                    <TableCell colSpan={columnDefsTwo?.length}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginTop: '20px',
                                                marginBottom: '20px',
                                                color: 'red',
                                                fontSize: '14px',
                                            }}
                                        >
                                            <span>{rdcn.noResultsFoundForFilters || 'No Results Found For The Selected Filters.'}</span>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableBody>}
                    </Table>
                </TableContainer>
            </Box>:''}
            <Box sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                height: '100px',
                border: '1px solid rgba(166, 168, 171, 0.5)',
                backgroundColor: '#F5FAFE', // Optional: to ensure it has a background
                padding: '12px 15px 4px 15px'
            }}>
                <Typography style={{ fontSize: '14px', fontWeight: '500', fontFamily: 'Roboto', lineHeight: '16.41px' }}>{rdcn.amountToBeReceivedForSelectedVouchers || 'Amount To Be Received For Selected Vouchers'}</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '12px', padding: '12px 0px 0px 0px' }}>

                    <Item sx={{ ...sx.itemsx, padding: 0, width: '7.3%' }} className={'input--wrapper'}>
                        <Lineinput id='totalAmt' value={btmSectData?.NetAmt||0} label={rdcn.totalAmt || 'Total Amt.'} disabled/>
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0, width: '7.3%' }} className={'input--wrapper'}>
                        <Lineinput id='paidAmt' value={btmSectData?.TotalPaidAmt||0} label={(rdcn.amountPaid || 'Amt. Paid').replace(/\n/g, ' ')} disabled/>
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0, width: '7.78%' }} className={'input--wrapper'}>
                        <Lineinput id='pendingAmt' value={btmSectData?.NetAmtPending||0} label={rdcn.amtPending || 'Amt. Pending'} disabled/>
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0, width: '7.3%' }} className={'input--wrapper'}>
                        <LineinputV2 id='discAmt' value={btmSectData?.Discount||0} label={rdcn.discount || 'Discount'} disabled
                        // type='number'
                        // onBlur={(e)=>{
                        //     const sanitizedValue = (e.target.value).replace(/[^0-9.]/g, '')
                        //         .replace(/(\..*?)\..*/g, '$1');
                        //     setBtmSectData((prev)=>({
                        //         ...prev,Discount:sanitizedValue,
                        //         TotalPendingAmount:btmSectData?.NetAmtPending-sanitizedValue
                        //     }))
                        // }}
                        />
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0, width: '7.3%' }} className={'input--wrapper'}>
                        <Lineinput id='netPendingAmt' value={btmSectData?.TotalPendingAmount||0} label={rdcn.netPending || 'Net Pending'} disabled/>
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0, width: '7.3%' }} className={'input--wrapper'}>
                        <Lineinput id='amtToRecv' value={btmSectData?.NetAmtToRcv||0} label={rdcn.amtRcv || 'Amt. Rcv.'}  onChange={(e)=>{
                            setBtmSectData((prev)=>({
                                ...prev,NetAmtToRcv:(e.target.value).replaceAll(/\D/g, '')
                            }))
                        }}
                        onKeyDown={(e)=>{navigation1(e,'btmPymentMethod','')}}
                        />
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0, width: '8.78%' }} className={'input--wrapper'}>
                        <DropDownOA
                            id={'btmPymentMethod'}
                            type="methd_of_paymnt"
                            label={(rdcn.paymentMode || 'Payment Mode').replace(/\n/g, ' ')}
                            // defaultvalue={'Cash'}
                            defaultvalue={btmSectData?.paymentMode?.ModeName || ''}
                            value={btmSectData?.paymentMode?.ModeName || ''}
                            // data={['Credit', 'Cash']}
                            data={methodOfPaymentData || []}
                            isObjArr={true}
                            dataKey={`ModeName`}
                            idKey={`ModeID`}
                            width="100%"
                            listWidth={'150px'}
                            searchPlaceholder={rdcn.searchMethodOfPayment || 'Search Method of Payment'}
                            nextId={btmSectData?.paymentMode?.ModeID === 2 || btmSectData?.paymentMode?.ModeID === 1?'remarks':'paymentRefId'}
                            prevId='amtToRecv'
                            resetFlag={resetDD}
                            onSelResetVal={true}
                            onSelect={(value) => {
                                setBtmSectData((prev) => ({
                                    ...prev, paymentMode: value
                                }))
                            }}
                        />
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0, width: '13.54%' }} className={'input--wrapper'}>
                        <Lineinput id='paymentRefId' value={btmSectData?.paymentRefId} label={rdcn.paymentRefId || 'Payment Ref. ID'} disabled={btmSectData?.paymentMode?.ModeID === 2 || btmSectData?.paymentMode?.ModeID === 1}
                        onChange={(e)=>{
                            setBtmSectData((prev)=>({
                                ...prev,paymentRefId:e.target.value,
                            }))
                        }}
                        onKeyDown={(e)=>{navigation1(e,'btmAccountNo','btmPymentMethod')}}
                        />
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0, width: '13.54%' }} className={'input--wrapper'}>
                        <DropDownOA
                            id={'btmAccountNo'}
                            type="account_number"
                            label={rdcn.accountNo || 'Account No.'}
                            defaultvalue={btmSectData?.bankAccNo}
                            // data={['Credit', 'Cash']}
                            data={bankAccountDetailData || []}
                            isObjArr={true}
                            dataKey={`AccountDet`}
                            idKey={`AccountNo`}
                            listWidth={'400px'}
                            resetFlag={resetDD}
                            onSelResetVal={true}
                            searchPlaceholder={rdcn.searchAccountNo || 'Search Account No.'}
                            // disabled={(selectedMethod?.ModeName==="Credit"?true:false)}
                            disabled={btmSectData?.paymentMode?.ModeID === 2 || btmSectData?.paymentMode?.ModeID === 1}
                            nextId=''
                            prevId=''
                            onSelect={(value) => {
                                setBtmSectData((prev) => ({
                                    ...prev, accountNo: value
                                }))
                            }}
                        />
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0, width: '13.54%' }} className={'input--wrapper'}>
                        <Lineinput id='remarks' value={btmSectData?.remarks} label={cs.remarks || 'Remarks'}  onChange={(e)=>{
                            setBtmSectData((prev)=>({
                                ...prev,remarks:e.target.value,
                            }))
                        }} 
                        onKeyDown={(e)=>{navigation1(e,'receiveBtn',btmSectData?.paymentMode?.ModeID === 2 || btmSectData?.paymentMode?.ModeID === 1?'btmPymentMethod':'btmAccountNo')}}
                        />
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0, width: '8.4%' }} className="disabled-wrapper">
                        <Button
                            variant="contained"
                            onKeyDown={(e) => navigation3(e, 'fromDate', 'remarks', () => { })}
                            id={'receiveBtn'}
                            sx={{ width: '100%', paddingY: '6px !important' }}
                            className="btn btn-primary"
                            onClick={handleReceiveBtn}
                        >
                            {cs.receive || 'Receive'}
                        </Button>
                    </Item>
                </Box>
            </Box>
            {showModal && modalType === 'showManageColumn' && (
                <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={updateModal} />
            )}
            <SuccessAndErrorModal handleClose={() => { handleCloseSuccessModal() }} open={isSave} title={cs.discountValueUpdatedSuccessfullyNl || 'Discount Value\nUpdated Successfully!'} modalStyle={modalStyle} />
            <SuccessAndErrorModal handleClose={() => { handleCloseSuccessModal() }} open={isSuccess} title={cs.amountReceivedSuccessfullyForSelectedVouchersNl || 'Amount Received Successfully \n For Selected Vouchers!'} modalStyle={modalStyle} />
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateAlertError, updateModal, getPartyConfigTableData, getPartyVoucherCreditData,updateInsertPartyVoucherDiscount,creditReceiveInsertUpdatePartyVoucher,  GetMOFPaymentUpdate,GetBankAccountDetailUpdate }
export default connect(mapStateToProps, mapDispatchToProps)(CreditVoucherTab)

